import React, { Suspense } from "react";

const Feedback = React.lazy(() => import("@/pages/feedback"));

export default function FeedbackContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <Feedback />
    </Suspense>
  );
}
